import React from 'react';
import { css } from 'aphrodite';
import Spinner from '~/src/components/Spinner';
import styles from '~/src/components/PageLayout/styles';

export type LoadingStep = {
  key: string;
  title: React.ReactNode;
  subtitle?: string;
};

type MultiStepLoadingOverlayProps = {
  className?: string;
  steps: LoadingStep[];
  currentStepIndex: number;
  relative?: boolean;
};

const MultiStepLoadingOverlay = ({
  className,
  steps,
  currentStepIndex,
  relative,
}: MultiStepLoadingOverlayProps) => {
  const currentStep = steps[currentStepIndex];

  return (
    <div
      className={`h-3/6 ${className} ${css(
        styles.loadingOverlayContainer,
        relative && styles.loadingOverlayContainerRelative,
      )}`}
    >
      <div style={{ textAlign: 'center', maxWidth: '500px', margin: '0 auto' }}>
        <Spinner />
        {currentStep && (
          <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                marginTop: '16px',
                fontSize: '14px',
                color: '#333',
              }}
            >
              <span>{currentStep.title}</span>
            </div>
            {currentStep.subtitle && (
              <h2 className={css(styles.loadingOverlaySubtitle)}>
                {currentStep.subtitle}
              </h2>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MultiStepLoadingOverlay;
